module.exports = __webpack_public_path__ + "img/zwischenzeiten11.52392123.jpg";